import { render, staticRenderFns } from "./SettingsBlockedUsers.vue?vue&type=template&id=5bd69bb2&scoped=true&"
import script from "./SettingsBlockedUsers.vue?vue&type=script&lang=js&"
export * from "./SettingsBlockedUsers.vue?vue&type=script&lang=js&"
import style0 from "./SettingsBlockedUsers.vue?vue&type=style&index=0&id=5bd69bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd69bb2",
  null
  
)

export default component.exports